export const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,5}$/i;
export const pwPattern = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,16}$/;
export const numberPattern = /^[0-9]*$/;
export const numberPointPattern = /^([1-9]{1}\d{0,1}|0{1})(\.{1}\d{0,2})?$/;
export const contributionAmountPattern = /^(\d{1,4})([.]\d{0,4}?)?$/;
export const ethaddrPattern = /^(0x)[0-9a-fA-F]{40}$/;
